import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as BookmarkIcon } from './bookmark.svg';

export const Bookmark = IconHOC(BookmarkIcon);
